export default "__VITE_ASSET__DlgZjRvm__"